import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'

import CONFIG from '../../../../config'
import { FormResponseStatus } from '../../../models'
import { Layout } from '../../../containers'
import { Title, Text, Card, LinkBack } from '../../../components/UI'
import { Modal, useModal } from '../../../components/UI/Modal'
import { AdminUserForm, AdminUserFormSuccess, RegisterFormError } from '../../../components'
import { authService } from '../../../services'

type RolesParams = 'paciente' | 'admin'

const AdminUserCreatePage:FC = ()  => {
  const history = useHistory()
  const { role } = useParams<{ role: RolesParams }>()

  if(role === 'admin' && !authService.isRoleByUserCurrent()) history.push(CONFIG.ROUTES.ADMIN.USERS.HOME)

  const modal = useModal()

  const getRoleId = (role: RolesParams) => {
    if(role === 'admin') return '1'
    else if(role === 'paciente') return '2'
    else return '0'
  }

  const onFormSubmitChange = (status: FormResponseStatus, message: string = '') => {
    modal.setStatus(status)
    modal.setMessage(message)
    modal.open()
  }

  return (
    <Layout role="ADMIN_ROLE">
      <div className="container register-wrapper pt-50 pb-70">
        <div className="d-flex justify-content-between">
          <Title border>Crear usuario</Title>

          <LinkBack link={CONFIG.ROUTES.ADMIN.USERS.HOME} />
        </div>

        <Text size="14" lineHeight="6" className="lg:fz-16 mt-40">Ingresa los datos requeridos para registrar un nuevo usuario en Mi Portal INDISA.</Text>

        <Card showOnly="lg" className="lg:py-70 lg:px-70 mt-50 lg:mt-25">
          <AdminUserForm roleId={getRoleId(role)} onSubmitChange={(status, userStatus, message) => onFormSubmitChange(status, message)} />
        </Card>
      </div>

      <Modal show={modal.show} maxWidth="490px" onClose={() => modal.close()}>
        {modal.status === 'SUCCESS' && <AdminUserFormSuccess wrapper onClick={() => modal.close()}>El usuario registrado recibirá un correo electrónico de confirmación</AdminUserFormSuccess>}
        {modal.status === 'ERROR' && <RegisterFormError message={modal.message} onClick={() => modal.close()}/>}
      </Modal>
    </Layout>
  )
}

export { AdminUserCreatePage }